import React from "react";

import CancelIcon from "@mui/icons-material/Cancel";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { useDispatch } from "react-redux";

function TrashRow({ uid }) {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch({ type: "REMOVE_ITEM_FROM_CART", payload: uid });
  };
  return (
    <Tooltip title="Remove item from cart">
      <IconButton aria-label="delete" size="small" onClick={handleClick}>
        <CancelIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
}

export default TrashRow;
